import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { AccountContext } from "../contexts/AccountContexts";
import { useTranslation } from "react-i18next";
import { ContentContext } from "../contexts/ContentContext";
import { MdClose } from "react-icons/md";
import { IoMdArrowDropleft, IoMdArrowDropright, IoMdArrowDropup } from "react-icons/io";

export function TextInput({ labelName, placeHolder, inputVariable, inputSetVariable, limit = 100 }) {
    const { t } = useTranslation("errors")
    const [errorMessage, setErrorMessage] = useState("")

    return (
        <div className="flex md:flex-auto md:flex-grow-0 md:flex-shrink-0 md:w-1/2 w-full px-2">
            <label className="form-control w-full">
                <div className="label">
                    <span className="label-text text-base font-semibold text-gray-800 dark:text-gray-300">
                        {labelName}
                    </span>
                </div>
                <input
                    type="text"
                    placeholder={placeHolder}
                    className="input input-bordered input-md w-full h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                    value={inputVariable}
                    required={true}
                    onChange={(e) => {
                        if (inputVariable.length > limit) {
                            return
                        }
                        else if (e.target.value.length > limit + 1) {
                            setErrorMessage("Input is too long.")
                            return
                        }
                        else if (e.target.value.length > limit) {
                            return
                        }
                        if (errorMessage !== "") {
                            setErrorMessage("")
                        }
                        inputSetVariable(e.target.value);
                    }}
                />
                <div className="label">
                    <span className="label-text-alt text-red-600">{t(errorMessage)}</span>
                    <span className="label-text-alt text-gray-800 dark:text-gray-300">{inputVariable.length}/{limit}</span>
                </div>
            </label>
        </div>
    );
}

export function TextInputSearch({ labelName, placeHolder, inputSetVariable }) {
    return (
        <div className="flex w-full px-2">
            <label className="form-control w-full">
                <div className="label">
                    <span className="label-text text-base font-semibold text-gray-800 dark:text-gray-300">
                        {labelName}
                    </span>
                </div>
                <input
                    type="text"
                    required={true}
                    placeholder={placeHolder}
                    className="input input-bordered input-md w-full h-10 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                    onChange={(e) => {
                        if (e.target.value.length > 80) {
                            return
                        }
                        inputSetVariable(e.target.value);
                    }}
                />
            </label>
        </div>
    );
}

export function TextLargeInput({
    labelName,
    placeHolder,
    inputVariable,
    inputSetVariable,
    wFull,
    classNames,
    id,
    limit = 100,
    isChat = false,
    focusTrigger = false
}) {

    const { t } = useTranslation("errors")
    const [errorMessage, setErrorMessage] = useState("")
    const { user } = useContext(AccountContext)
    const textareaRef = useRef(null)

    useEffect(() => {
        if (focusTrigger && textareaRef.current) {
            textareaRef.current.focus()
        }
    }, [focusTrigger])

    return (
        <div className={`flex w-full px-2 ${classNames}`}>
            <label className="form-control w-full">

                <div className={`label ${isChat ? "hidden sm:flex" : ""}`}>
                    <span className="label-text text-base font-semibold text-gray-800 dark:text-gray-300">
                        {labelName}
                    </span>
                </div>
                <textarea
                    id={id}
                    placeholder={placeHolder}
                    value={inputVariable.length <= 0 && user.name == "Faena" ?
                        `Merhaba,
Sizlere her zaman daha adil, hoşgörülü ve keyifli bir oyun ortamı sunmak için çalışmalarımızı sürdürüyoruz. Bu kapsamda raporlama sistemimizde bazı değişiklikler yapılmıştır. Artık küfür, hakaret, oyun dışı ticaret ve benzeri şikayetler yalnızca oyun içinden oyuncunun üstüne tıkladıktan sonra gelen seçeneklerde Şikayet(!) simgesine basarak rapor etme yöntemiyle yapılabilecektir. Destek sistemi üzerinden gönderilen şikayetler ve ekran görüntüsü gibi kanıtlar artık kabul edilmeyecektir. Yöneticiler, oyun içi rapor sistemi üzerinden iletilen şikayetleri inceleyerek gerekli işlemleri yapacaktır. Lütfen bu yeni sistemle birlikte küfür hakaret şikayetlerinizi yalnızca oyun içinden göndermeyi unutmayınız.
Anlayışınız için teşekkür eder, iyi oyunlar dileriz.`
                        : inputVariable
                    }
                    defaultValue={
                        user.name == "Faena" &&
                        `Merhaba,
Sizlere her zaman daha adil, hoşgörülü ve keyifli bir oyun ortamı sunmak için çalışmalarımızı sürdürüyoruz. Bu kapsamda raporlama sistemimizde bazı değişiklikler yapılmıştır. Artık küfür, hakaret, oyun dışı ticaret ve benzeri şikayetler yalnızca oyun içinden oyuncunun üstüne tıkladıktan sonra gelen seçeneklerde Şikayet(!) simgesine basarak rapor etme yöntemiyle yapılabilecektir. Destek sistemi üzerinden gönderilen şikayetler ve ekran görüntüsü gibi kanıtlar artık kabul edilmeyecektir. Yöneticiler, oyun içi rapor sistemi üzerinden iletilen şikayetleri inceleyerek gerekli işlemleri yapacaktır. Lütfen bu yeni sistemle birlikte küfür hakaret şikayetlerinizi yalnızca oyun içinden göndermeyi unutmayınız.
Anlayışınız için teşekkür eder, iyi oyunlar dileriz.`
                    }
                    ref={textareaRef}
                    className={`textarea textarea-bordered input-md w-full ${wFull ? "h-20 sm:h-40" : limit ? "h-20" : "h-20 sm:h-40"
                        } bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300`}
                    onChange={(e) => {
                        if (limit && inputVariable.length > limit) {
                            return
                        }
                        else if (limit && e.target.value.length > limit + 1) {
                            setErrorMessage("Input is too long.")
                            return
                        }
                        else if (limit && e.target.value.length > limit) {
                            return
                        }
                        if (errorMessage !== "") {
                            setErrorMessage("")
                        }
                        inputSetVariable(e.target.value);
                    }}
                />
                {
                    limit &&
                    <div className="label">
                        <span className="label-text-alt text-red-600">{t(errorMessage)}</span>
                        <span className="label-text-alt text-gray-800 dark:text-gray-300">{inputVariable.length}/{limit}</span>
                    </div>
                }
            </label>
        </div>
    );
}

export function TextLargeInputChat({
    labelName,
    placeHolder,
    wFull,
    classNames,
    getData,
    id
}) {

    const [content, setContent] = useState("")

    const handleBlur = useCallback(() => {
        getData(content)
    }, [content, getData])


    return (
        <div className={`flex w-full px-2 ${classNames}`}>
            <label className="form-control w-full">
                <div className="label">
                    <span className="label-text text-base font-semibold text-gray-800 dark:text-gray-300">
                        {labelName}
                    </span>
                </div>
                <textarea
                    id={id}
                    placeholder={placeHolder}
                    value={content}
                    onBlue={handleBlur}
                    className={`textarea textarea-bordered input-md w-full ${wFull ? "h-40" : "h-20"
                        } bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300`}
                    onChange={(e) => {
                        setContent(e.target.value);
                    }}
                />
            </label>
        </div>
    );
}

export function TextLargeInputWithTags({ inputSetVariable, reset, setReset, classNames }) {
    const { t } = useTranslation('common')
    const { user, devs } = useContext(AccountContext)
    const defaultTag = "####"
    const [newTag, setNewTag] = useState(defaultTag)
    const textBoxRef = useRef(null);
    const [content, setContent] = useState("")

    const [newTagAdded, setNewTagAdded] = useState(false);


    const handleTagSelect = (dev) => {

        // Get cursor
        const selection = window.getSelection();
        const node = selection.anchorNode;
        const cursorPosition = selection.anchorOffset;

        const text = node ? node.textContent : '';
        const substring = text.substring(-1, cursorPosition);
        const atIndex = substring.lastIndexOf('@');


        // Get tag component with name
        const tagHTML = `<span class="tagged-user" contenteditable="false">@${dev.name}</span>&nbsp;`;
        const tempHTML = `<span id="temp-cursor-inserter"></span>`

        const range = selection.getRangeAt(0);

        // Clone the range to manipulate without affecting actual selection
        const preCursorRange = range.cloneRange();
        // Set the end of the cloned range to the cursor position (collapse to the start)
        preCursorRange.collapse(true);
        // Move the start of the range to the beginning of the div
        preCursorRange.setStart(textBoxRef.current, 0);
        // Extract content before cursor as text and html
        const textBeforeCursor = preCursorRange.toString();
        // const htmlBeforeCursor = getHTMLFromRange(preCursorRange);
        const textBeforeAt = textBeforeCursor.substring(0, atIndex);
        let htmlBeforeAt = ""
        if (textBeforeAt === "") {
        }
        else {
            htmlBeforeAt = extractHTMLBeforeAt(preCursorRange, atIndex, textBeforeCursor);
        }

        // --- Get content after the cursor ---
        const postCursorRange = range.cloneRange();
        postCursorRange.collapse(false);
        postCursorRange.setEndAfter(textBoxRef.current.lastChild);

        const textAfterCursor = postCursorRange.toString();
        const htmlAfterCursor = getHTMLFromRange(postCursorRange);

        // const newHTML = htmlBeforeAt + tagHTML + " " + tempHTML + htmlAfterCursor
        const newHTML = htmlBeforeAt + tagHTML + tempHTML + htmlAfterCursor

        setContent(newHTML)
        textBoxRef.current.innerHTML = newHTML

        const regex = /<span[^>]*class=["']tagged-user["'][^>]*>(.*?)<\/span>/g;
        const matches = [...htmlBeforeAt.matchAll(regex)].map(match => match[1]);
        let totalTagLengths = 0
        if (matches.length > 0) {

            totalTagLengths = matches.reduce((a, b) => a + b)
            totalTagLengths = totalTagLengths.length
        }

        setFilterSelectIndex(1)
        setNewTag(defaultTag)
        setFilteredDevs([])

        setNewTagAdded(true)

    }

    function moveCursorToMarker(contentEditableDiv) {
        const markerId = 'temp-cursor-inserter';

        // Find the marker within the provided contentEditableDiv
        const markerSpan = contentEditableDiv.querySelector(`#${markerId}`);
        if (!markerSpan) return; // Exit if the marker is not found


        contentEditableDiv.focus();

        // Get the range and selection objects
        const range = document.createRange();
        const selection = window.getSelection();

        // Set the range after the marker span
        range.setStartAfter(markerSpan);
        range.setEndAfter(markerSpan);

        // Remove the marker span from the contentEditable
        setTimeout(() => {

            markerSpan.parentNode.removeChild(markerSpan);
        }, 100)
        // setContent(contentEditableDiv.innerHTML)
        // textBoxRef.current.innerHTML = 

        // Update the selection to place the cursor
        selection.removeAllRanges();
        selection.addRange(range);
    }


    const getHTMLFromRange = (range) => {
        const div = document.createElement('div');
        div.appendChild(range.cloneContents());
        return div.innerHTML;
    };

    const extractHTMLBeforeAt = (range, atIndex, fullText) => {
        const clonedRange = range.cloneRange();

        // Convert the range to string to get the position of the last "@" relative to its text length
        const preCursorText = clonedRange.toString();

        // Calculate the correct offset for setEnd
        const lengthToCut = preCursorText.length - (fullText.length - atIndex);

        // Loop through the nodes to find the exact one that contains the "@"
        let remainingLength = lengthToCut;
        let currentNode = clonedRange.endContainer;

        while (remainingLength > 0 && currentNode) {
            if (currentNode.nodeType === Node.TEXT_NODE) {
                const textContentLength = currentNode.textContent.length;
                if (remainingLength <= textContentLength) {
                    clonedRange.setEnd(currentNode, remainingLength);
                    break;
                } else {
                    remainingLength -= textContentLength;
                }
            }
            currentNode = currentNode.previousSibling;
        }

        return getHTMLFromRange(clonedRange);
    };

    const handleKeyUp = (e) => {

        if (e.key === "Escape") {
            setFilteredDevs([])
            setNewTag(defaultTag)
        }

        if (e.key === "Enter") {
            return
        }
        const selection = window.getSelection();
        const node = selection.anchorNode;
        const text = node ? node.textContent : '';
        const cursorPosition = selection.anchorOffset;
        const substring = text.substring(-1, cursorPosition);

        const range = selection.getRangeAt(0);

        // Clone the range to manipulate without affecting actual selection
        const preCursorRange = range.cloneRange();
        // Set the end of the cloned range to the cursor position (collapse to the start)
        preCursorRange.collapse(true);
        // Move the start of the range to the beginning of the div
        preCursorRange.setStart(textBoxRef.current, 0);
        // Extract content before cursor as text and html
        const textBeforeCursor = preCursorRange.toString();
        const htmlBeforeCursor = getHTMLFromRange(preCursorRange);


        // Detect if the user typed "@"
        const atIndex = substring.lastIndexOf('@');
        if (atIndex >= 0 && !htmlBeforeCursor.endsWith("</span>")) {
            const tagText = substring.slice(atIndex + 1);
            setNewTag(tagText)
        }
        else {
            setNewTag(defaultTag)

        }
        setContent(textBoxRef.current.innerHTML)
    }

    useEffect(() => {
        const regex = /<span[^>]*class=["']tagged-user["'][^>]*>(.*?)<\/span>/g;
        let result = content.replace(regex, (match, p1) => p1);
        result = cleanHtmlText(result)
        inputSetVariable(result)
    }, [content])

    useEffect(() => {
        if (reset) {
            textBoxRef.current.innerHTML = ""
            setContent("")
            setReset(false);
        }
    }, [reset])

    function cleanHtmlText(inputText) {
        // Replace <br> tags with newlines
        inputText = inputText.replaceAll("<div>", "<br><div>")
        inputText = inputText.replaceAll("<br>", '\n')
        let cleanedText = inputText.replaceAll(/<br\s*\/?>/gi, '\n');

        // Remove all other HTML tags
        cleanedText = cleanedText.replaceAll(/<\/?[^>]+(>|$)/g, '');

        // Optionally, replace multiple spaces with a single space
        cleanedText = cleanedText.replaceAll(/&nbsp;/gi, ' '); // Replace HTML space entities
        // cleanedText = cleanedText.replace(/\s\s+/g, ' '); // Collapse multiple spaces

        return cleanedText;
    }

    useEffect(() => {
        textBoxRef.current.addEventListener('keyup', handleKeyUp);

        return () => {
            if (textBoxRef.current) {
                textBoxRef.current.removeEventListener('keyup', handleKeyUp);
            }
        };
    }, [devs]);


    const [filteredDevs, setFilteredDevs] = useState([]);
    const [filterSelectIndex, setFilterSelectIndex] = useState(1)

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && filteredDevs.length > 0) {
            e.preventDefault()
            if (filterSelectIndex === 0) {
                tagEverybody()
            }
            else {
                handleTagSelect(filteredDevs[filterSelectIndex - 1])
            }

        }
        else if (e.key === "Enter") {

        }
    }

    const handleKeyDown = (e) => {
        e = e || window.event;

        if (filteredDevs.length > 0) {

            if (e.keyCode == '38') {
                e.preventDefault()
                // up arrow
                if (filterSelectIndex - 1 < 0) {
                    setFilterSelectIndex(filteredDevs.length)
                } else {
                    setFilterSelectIndex(filterSelectIndex - 1)
                }
            }
            else if (e.keyCode == '40') {
                e.preventDefault()
                // down arrow
                if (filterSelectIndex + 2 > filteredDevs.length + 1) {
                    setFilterSelectIndex(1)
                } else {
                    setFilterSelectIndex(filterSelectIndex + 1)
                }

            }
        }
    }

    useEffect(() => {
        if (newTag !== defaultTag) {

            let filtered = []
            Object.values(devs).map((dev, index) => {
                if (user.id !== dev.id && dev.name.toLowerCase().includes(newTag.toLowerCase())) {
                    filtered.push(dev)
                }
            })
            setFilteredDevs(filtered)
        }
        else {
            setFilteredDevs([])
        }
    }, [content, newTag])

    useEffect(() => {
        textBoxRef.current.addEventListener('keypress', handleKeyPress);

        return () => {
            if (textBoxRef.current) {
                textBoxRef.current.removeEventListener('keypress', handleKeyPress);
            }
        };
    });

    // useEffect(() => {
    //   if (textBoxRef.current.innerHTML !== content) {
    //     textBoxRef.current.innerHTML = content;
    //   }
    // });

    useEffect(() => {
        if (textBoxRef.current.innerHTML !== content) {
            setContent(textBoxRef.current.innerHTML);
        }
    });

    useEffect(() => {
        textBoxRef.current.addEventListener('keydown', handleKeyDown);
        return () => {
            if (textBoxRef.current) {
                textBoxRef.current.removeEventListener('keydown', handleKeyDown);

            }
        }
    })

    useEffect(() => {

        if (newTagAdded) {
            moveCursorToMarker(document.getElementById("editableTagDiv"))
            setNewTagAdded(false)
            setNewTag(defaultTag)
        }

    }, [newTagAdded])

    const tagEverybody = () => {
        for (let i = 0; i < Object.keys(devs).length; i++) {
            let dev = devs[Object.keys(devs)[i]]
            if (dev.id === user.id) {
                continue
            }
            handleTagSelect(dev)
        }
    }

    return (
        <div className={`flex w-full px-2 relative h-full flex-1`}>
            <div className="absolute bottom-full flex flex-col ">
                {
                    filteredDevs.length !== 0 &&

                    <button
                        className={`btn btn-sm text-gray-800 dark:text-gray-300 ${filterSelectIndex === 0 ? "border-primary/70 bg-sky-100 dark:bg-sky-800" : "bg-white dark:bg-gray-700 border-primary/20"}  hover:bg-white dark:hover:bg-gray-600 border  hover:border-primary/70`}
                        onClick={tagEverybody}
                    >{t('All')}</button>
                }
                {filteredDevs.filter((dev) => user.id !== dev.id).map((dev, index) =>
                    <button
                        key={index} className={`btn btn-sm text-gray-800 dark:text-gray-300 ${filterSelectIndex === index + 1 ? "border-primary/70 bg-sky-100 dark:bg-sky-800" : "bg-white dark:bg-gray-700 border-primary/20"}  hover:bg-white dark:hover:bg-gray-600 border  hover:border-primary/70`}
                        onClick={() => handleTagSelect(dev)}
                    >{dev.name}</button>
                )}

            </div>
            <div
                ref={textBoxRef}
                contentEditable={true}
                id="notesEditableTagDiv"
                className={`textarea textarea-bordered max-w-full flex-1 overflow-y-auto cursor-text bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300 ${classNames ? classNames : "max-h-40 min-h-12 lg:h-40"}`}
                suppressContentEditableWarning={true}
            >
            </div>

        </div>
    )
}


export function SelectInput({
    labelName,
    placeHolder,
    inputSetVariable,
    options,
}) {
    const { t } = useTranslation('common')
    return (
        <div className="flex md:flex-auto md:flex-grow-0 md:flex-shrink-0 md:w-1/2 w-full px-2">
            <label className="form-control w-full">
                <div className="label">
                    <span className="label-text text-base font-semibold text-gray-800 dark:text-gray-300">
                        {labelName}
                    </span>
                </div>
                <select required className="select select-bordered select-md w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" onChange={(e) => { inputSetVariable(e.target.value); }}>
                    <option disabled selected>{t(placeHolder)}</option>
                    {options.map((option, index) => (
                        <option key={index} value={option}>{t(option)}</option>
                    ))}
                </select>
            </label>
        </div>
    );
}

export function FileInput({ inputVariable, inputSetVariable, classNames }) {
    const { t } = useTranslation(['common', 'errors'])
    const [inputKey, setInputKey] = useState(Date.now());
    const { openErrorModal } = useContext(ContentContext)
    const clearFiles = () => {
        setInputKey(Date.now()); // Reset key to re-render input
    };
    useEffect(() => {
        if (inputVariable.length === 0) {
            clearFiles()
        }
    }, [inputVariable])

    const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/bmp",
        "image/webp",
        "image/svg+xml",
        "text/plain",
        "video/mp4",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];
    const handleFileChange = (e) => {
        let allowedFiles = []
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            if (file && allowedTypes.includes(file.type)) {
                allowedFiles.push(file)
            }
            else {
                openErrorModal({
                    status: "",
                    message: t("Unacceptable file type", { ns: "errors" })
                })
                return []
            }
        }
        return allowedFiles
    };

    return (
        <div className="flex md:flex-auto md:flex-grow-0 md:flex-shrink-0 lg:w-1/2 w-full px-2">
            <label className="form-control w-full max-w-xs">
                <div className="label">
                    <span className="label-text font-semibold text-gray-800 dark:text-gray-300">{t('Choose File Here')}</span>
                </div>
                <input
                    key={inputKey}
                    type="file"
                    accept=".jpg,.jpeg,.png,.bmp,.webp,.svg,.txt,.pdf,.docx"
                    data-theme="light"
                    multiple
                    className={`file-input file-input-bordered h-7 sm:h-12 w-full sm:min-w-72 max-w-xs ${classNames} bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300`}
                    onChange={(e) => {
                        inputSetVariable(handleFileChange(e));
                    }}
                />
            </label>
        </div>
    );
}


export function FileInputExtended({ inputVariable, inputSetVariable, inputId = 0 }) {
    const { t } = useTranslation(['common', 'errors'])
    const [inputKey, setInputKey] = useState(Date.now());
    const { openErrorModal } = useContext(ContentContext)

    const [filesOpen, setFilesOpen] = useState(false)
    const filesRef = useRef(null)
    const openFilesButtonRef = useRef(null)

    const clearFiles = () => {
        setInputKey(Date.now()); // Reset key to re-render input
    };
    useEffect(() => {
        if (inputVariable.length === 0) {
            setFilesOpen(false)
            clearFiles()
        }
    }, [inputVariable])

    const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/bmp",
        "image/webp",
        "image/svg+xml",
        "text/plain",
        "video/mp4",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];
    const handleFileChange = (e) => {
        let allowedFiles = []
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            if (file && allowedTypes.includes(file.type)) {
                allowedFiles.push(file)
            }
            else {
                openErrorModal({
                    status: "",
                    message: t("Unacceptable file type", { ns: "errors" })
                })
                return []
            }
        }
        return allowedFiles
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filesRef.current && !filesRef.current.contains(event.target) && openFilesButtonRef.current && !openFilesButtonRef.current.contains(event.target)) {
                setFilesOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="flex flex-col px-2">
            <div className="label">
                <span className="label-text font-semibold text-gray-800 dark:text-gray-300">{t('Choose File Here')}</span>
            </div>
            <div className="flex mx-1 items-center border border-gray-400  max-w-max rounded-md">
                <label className="form-control w-full max-w-max">
                    <input
                        key={inputKey}
                        type="file"
                        id={`fileInput_${inputId}`}
                        accept=".jpg,.jpeg,.png,.bmp,.webp,.svg,.txt,.pdf,.docx,.mp4"
                        data-theme="light"
                        multiple
                        className={`hidden `}
                        onChange={(e) => {
                            inputSetVariable(handleFileChange(e));
                        }}
                    />
                    <label
                        htmlFor={`fileInput_${inputId}`}
                        className="cursor-pointer select-none px-4 py-2 bg-slate-800 text-white rounded-l-md hover:bg-slate-700 max-w-max text-nowrap"
                    >
                        {t('Choose files')}
                    </label>
                </label>
                <div className="flex flex-col relative">
                    {
                        <div className="flex gap-3 items-center select-none max-w-max rounded-r-md py-2  px-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-600 hover:dark:bg-gray-500 cursor-pointer" onClick={() => setFilesOpen(!filesOpen)} ref={openFilesButtonRef}>
                            <span className="text-nowrap truncate max-w-[135px] hidden min-[350px]:flex">{t("Chosen files")} </span>
                            <span>{inputVariable?.length}</span>
                            <div className={`${!inputVariable?.length && "invisible"}`}>
                                {
                                    filesOpen
                                        ?
                                        <IoMdArrowDropup />
                                        :
                                        <>
                                            <div className="ltr:hidden">
                                                <IoMdArrowDropleft />
                                            </div>
                                            <div className="rtl:hidden">
                                                <IoMdArrowDropright />
                                            </div>
                                        </>
                                }
                            </div>
                        </div>
                    }
                    <div className="flex flex-col absolute bottom-full" ref={filesRef}>

                        {
                            filesOpen &&
                            inputVariable.map((el, index) =>
                                <div key={index} className="flex gap-1 items-center select-none rounded-md bg-gray-100 py-1 px-2 hover:bg-gray-200 dark:bg-gray-600 hover:dark:bg-gray-500 cursor-pointer"
                                    onClick={() => {
                                        let i = inputVariable.indexOf(el)
                                        let prev = inputVariable
                                        if (i > -1) {
                                            prev.splice(i, 1)
                                        }
                                        inputSetVariable(prev)
                                    }}
                                >
                                    <div>
                                        <MdClose size={15} />
                                    </div>
                                    <div className="flex items-center max-w-[230px] w-full ">

                                        <span className="truncate">{el.name.split(".")[0]}</span>
                                        <span className="">.{el.name.split(".")[1]}</span>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
